import React from "react";

import { Col, Row } from "antd";

export default function PageTitle(props) {
  const { pageTitle, pageText, color } = props;

  return (
    <Col span={24} style={{ paddingLeft: "0" }}>
      <Row>
        <Col span={24}>
          {pageTitle && (
            <h3
              style={{
                color: color || null,
              }}
              className="hp-mb-8"
            >
              {pageTitle}
            </h3>
          )}
        </Col>

        <Col span={24}>
          {pageText && <p className="hp-mb-0 hp-p1-body">{pageText}</p>}
        </Col>
      </Row>
    </Col>
  );
}
